import { render } from "./ReceiverSelectionComponent.vue?vue&type=template&id=a63564f0&scoped=true&ts=true"
import script from "./ReceiverSelectionComponent.vue?vue&type=script&lang=ts"
export * from "./ReceiverSelectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a63564f0"]])

export default __exports__